<template>
    <el-main>
        <div class="breadcrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>Settings</el-breadcrumb-item>
                <el-breadcrumb-item>Office City</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-row style="margin-top: 24px">
            <el-col :span="18">
                <div class="main-title">
                    Office City List
                </div>
            </el-col>
            <el-col :span="6" class="text-right">
                <el-button type="primary" size="small" icon="el-icon-plus" @click="isEdit = false; resetForm(); showCreateDialog = true">New City</el-button>
            </el-col>
        </el-row>

        <el-card  style="margin-top: 24px"  class="box-card">
            <div slot="header" class="clearfix">
                <span>Filter</span>
            </div>
            <el-row>
                <el-col :span="6">
                    <el-select
                            style="width: 100%"
                            value-key="id"
                            v-model="query.country"
                            filterable
                            remote
                            clearable
                            auto-complete="nope"
                            placeholder="Select Country"
                            :remote-method="searchCountry"
                            :loading="searchingCountry"
                            size="small"
                            @clear="searchCountry('')">
                        <el-option
                                v-for="item in countries"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="3" style="margin-left: 8px">
                    <el-button @click="searchData" class="filter-item" size="small" type="primary" icon="el-icon-search">
                        Search
                    </el-button>
                </el-col>
            </el-row>
        </el-card>

        <el-row type="flex" style="margin-top:24px">
            <el-col :span="24">
                <el-card class="box-card">
                    <el-row style="margin-bottom: 18px" :gutter="15">
                        <el-col :span="4" :offset="16">
                            <status-filter v-model="query.status" @change="queryStatusChanged()"></status-filter>
                        </el-col>
                        <el-col :span="4">
                            <el-input v-model="query.search" size="small" placeholder="Name" class="filter-item" @keyup.enter.native="search"/>
                        </el-col>
                    </el-row>

                    <el-table
                            v-loading="loading"
                            :data="cities"
                            stripe
                            @sort-change="sortChange"
                            :default-sort="query.sort"
                            style="width: 100%">
                        <el-table-column
                                prop="id"
                                label="ID"
                                width="80"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                prop="name"
                                label="Name"
                                min-width="180"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                prop="description"
                                label="Description"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                prop="active"
                                label="Status"
                                width="100"
                                sortable>
                            <template slot-scope="scope">
                                {{scope.row.active ? 'Active':'Inactive'}}
                            </template>
                        </el-table-column>
                        <el-table-column 
                                label="Actions"
                                width="100">
                            <template slot-scope="scope">
                                <el-button size="mini" icon="el-icon-edit" @click="isEdit = true; edit(scope.$index, scope.row)"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <pagination v-show="query.total>0" :total="query.total" :page.sync="query.page" :limit.sync="query.limit" @pagination="searchData" />
                </el-card>
            </el-col>
        </el-row>
        <el-dialog v-bind:title="dialogTitle" :visible.sync="showCreateDialog">
            <el-form :model="form" ref="cityForm" :rules="cityRules" v-loading="saving">
                <el-form-item :required="!isEdit" label="City" :label-width="formLabelWidth" prop="city">
                    <el-select
                            v-if="!isEdit"
                            value-key="description"
                            v-model="form.city"
                            :loading="cityLoading"
                            filterable
                            remote
                            :remote-method="searchCity"
                            placeholder="Select City"
                            :disabled="isEdit">
                        <el-option
                                v-for="item in cityData"
                                :key="item.id"
                                :label="item.description"
                                :value="item">
                        </el-option>
                    </el-select>
                    <span v-if="isEdit">{{form.cityName}}</span>
                </el-form-item>
                <el-form-item label="Description" :label-width="formLabelWidth" prop="description">
                    <el-input type="textarea" v-model="form.description"></el-input>
                </el-form-item>
                <el-form-item >
                    <div class="switch-label" style="width: 108px;" >Active</div> <el-switch v-model="form.active"></el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="showCreateDialog = false">Cancel</el-button>
                <el-button size="small" type="primary" @click="save()">Save</el-button>
            </span>
        </el-dialog>
    </el-main>
</template>

<script>
import _ from "lodash";
import api from "@/services/api/WRCService"
import axios from "axios";
import countryData from "country-json/src/country-by-abbreviation.json";
import Pagination from "@/components/Pagination"
import StatusFilter from '@/components/StatusFilter'

export default {
    components: { Pagination, StatusFilter },
    data: function() {
        var validateCity = (rule, value, callback) => {
            if (!value) {
                if (_.isUndefined(this.form.id)) {
                    callback(new Error('Please select City'));
                } else {
                    callback()
                }
            } else {
                if (_.isUndefined(this.form.id)) {
                    var countryCode = value.country

                    this.countryLoading = true;
                    
                    api.getCountry(countryCode).then(({ data }) => {
                        this.form.country = data.data
                        callback();
                    }).catch(() => {
                        callback(new Error('Selected City\'s country doesnt exist in record'));
                    }).then(() => {
                        this.loading = false;
                    });
                } else {
                    callback();
                }
            }
        };
        return {
            cityRules: {
                city: [
                    { validator: validateCity, trigger: 'change' }
                ]
            },
            countries: [],
            showCreateDialog: false,
            formLabelWidth: '120px',
            form: {
              description: '',
              active: true
            },
            dialogTitle: 'New Office City',
            saving: false,
            loading: false,
            countryLoading: false,
            searchingCountry: false,
            cityLoading: false,
            cities: [],
            countryData:[],
            cityData:[],
            isEdit: false,
            query: {
                total: 0,
                page: 0,
                limit: 10,
                pageSize: 0,
                search: null,
                country: null,
                status: "Active",
                sort: {
                    prop: 'id',
                    order: 'ascending',
                    orderVal: 'asc'
                }
            }
        }
    },
    watch: {
        form : function() {
            if (_.isUndefined(this.form.id)) {
                this.dialogTitle = 'New Office City';
            } else {
                this.dialogTitle = 'Edit Office City';
            }
        }
    },
    methods:{
        search() {
            this.query.page = 1;
            this.searchData();
        },
        searchData() {
            this.loading = true;

            var active = null

            if (this.query.status === "Active") {
                active = true
            } else if (this.query.status === "Inactive") {
                active = false
            }

            api.getCities({
                name: this.query.search,
                countryId: this.query.country
            },{
                page: this.query.page - 1,
                size: this.query.limit,
                sort: this.query.sort.prop,
                dir: this.query.sort.orderVal
            }, active).then(({ data }) => {
                this.cities.splice(0, this.cities.length);
                this.cities.push(...data.data.items);
                this.query.total = data.data.pagination.totalRecords;
            }).catch(() => {}).then(() => {
                this.loading = false;
            });
        },
        queryStatusChanged() {
            this.search()
        },
        searchCountry(query) {
            this.searchingCountry = true;
            api.getCountries(query, {
                page: 0,
                size: 200
            }).then(({data}) => {
                this.countries.splice(0, this.countries.length);
                if(query === ''){
                    this.countries.push({
                        id: null,
                        name: 'Select Country'
                    })

                    this.query.country = null;
                }
                this.countries.push(...data.data.items);
            }).catch(() => {}).then(() => {
                this.searchingCountry = false;
            });
        },
        searchCity(query) {
            this.cityLoading = true

            axios.get('/v1/settings/cities?query=' + query).then(({ data }) => {

                this.cityData = data.predictions;
            }).catch(() => {}).then(() => {
                this.cityLoading = false;
            });
        },
        sortChange(data) {
            const { prop, order } = data;
            if(prop == null){
                this.query.sort = {
                    prop: 'id',
                    order: 'ascending',
                    orderVal: 'asc'
                };
            }else {
                this.query.sort = {
                    prop: prop,
                    order: order,
                    orderVal: order === 'ascending' ? 'asc' : 'desc'
                }
            }

            this.searchData()
        },
        edit(idx, data) {
            var country = _.find(this.countryData, function(c) { return c.country === data.name; });
            this.form = {
                id: data.id,
                cityName: data.name,
                country: country,
                description: data.description,
                active: data.active
            };

            this.showCreateDialog = true;
        },
        resetForm() {
            this.saving = false;

            this.form = {
              description: '',
              active: true
            }

            setTimeout(() => {
                if (!_.isUndefined(this.$refs['cityForm'])) {
                    this.$refs['cityForm'].clearValidate();
                }
            }, 1);
        },
        save() {
            this.$refs['cityForm'].validate((valid) => {
                if (valid) {
                    this.saving = true;
                    if (_.isUndefined(this.form.id)) {
                        this.form.countryCode = this.form.country.code;
                        this.form.name = this.form.city.structured_formatting.main_text;
                        
                        api.createCities(this.form).then(() => {
                            this.$message({
                              message: 'Successfully added Office City.',
                              type: 'success'
                            });
                        }).catch(() => {}).then(() => {
                            this.saving = false;
                            this.searchData();
                            this.showCreateDialog = false;
                        });
                    } else {
                        let params = {
                            cityId: this.form.id,
                            description: this.form.description,
                            active: this.form.active
                        }

                        api.updateOfficeCity(params).then(() => {
                            this.$message({
                              message: 'Successfully updated Office City.',
                              type: 'success'
                            });
                        }).catch(() => {}).then(() => {
                            this.saving = false;
                            this.searchData();
                            this.showCreateDialog = false;
                        });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        }
    },
    mounted() {
        this.query.page = 1;
        this.searchData();
        this.searchCountry('');
        this.countryData = countryData;
    }
}
</script>
